<div class="container-fluid si-layout-main-padding">
  @if (results(); as currentResults) {
    <div class="heading mb-6 d-flex justify-content-between">
      <div>
        <h2>
          {{ 'RESULTS.SIMULATION_RESULTS_FOR' | translate }}:
          {{ getScheduleName(currentResults) }}
        </h2>
        @if (chooseSimulationKernel() && kernelTimeMs() !== undefined) {
          <div class="d-flex gap-5 mt-1">
            <small class="text-secondary">
              Kernel time: <strong>{{ kernelTimeMs() }} ms</strong>
            </small>
            @if (totalTimeMs() !== undefined) {
              <small class="text-secondary">
                Total time: <strong>{{ totalTimeMs() }} ms</strong>
              </small>
            }
          </div>
        }
      </div>
      <button
        type="button"
        class="btn btn-secondary"
        [cdkMenuTriggerFor]="exportContextMenuResults"
      >
        <i class="icon element-import"></i>Export
      </button>
    </div>

    <div class="row mb-9">
      <app-infos [results]="currentResults" />
    </div>
    <div class="row mb-9">
      <app-plots [results]="currentResults" />
    </div>
    <div class="row mb-9">
      <app-usercharts [results]="currentResults" />
    </div>
    <div class="row mb-9">
      <app-tables [results]="currentResults" />
    </div>
  } @else {
    @if (simulationRunning()) {
      <h2>
        {{ 'RESULTS.SIMULATION_FOR_RUNNING' | translate: { name: simulatingSchedule()?.name } }}
        <span class="loading-dots"></span>
      </h2>
      <si-loading-spinner />
    } @else {
      <si-empty-state
        empty-content
        icon="element-technical-operator"
        [heading]="'RESULTS.INFO_SIMULATE_SCHEDULE' | translate"
      />
    }
  }
</div>

<ng-template #exportContextMenuResults>
  <si-menu>
    @if (canExportPptx()) {
      <si-menu-item [disabled]="pptxExporting()" (click)="exportResultsAsPptx()">
        {{ pptxExporting() ? 'Generating PPTX…' : 'Download PPTX' }}
      </si-menu-item>
    }
    <si-menu-item (click)="exportResultsAsTable()">Export Results as JSON</si-menu-item>
    <si-menu-item (click)="exportResultsAsExcel()">Export Results as Excel</si-menu-item>
  </si-menu>
</ng-template>
